import SectionWrapper from "../hoc/SectionWrapper";
import { SVGS } from ".";
import { domain } from "../consts";
import { useEffect, useState } from "react";
import { TestimonialStrings } from "../consts/strings";
const Testimonials = () => {
  const [feedbacks, setFeedbacks] = useState([]);

  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const response = await fetch(
          `${domain}/feedbacks`,

          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const feedbacksData = await response.json();

        setFeedbacks(feedbacksData);
      } catch (error) {
        console.error("Error fetching RSVP or template:", error);
      }
    };

    fetchFeedbacks();
  }, []);

  return (
    <div className="text-gray-600   h-fit" id="reviews">
      <div className="mb-20 space-y-4 px-6 md:px-0">
        <h2 className="text-center text-xl font-bold text-gray-800   md:text-3xl">
          {TestimonialStrings.header}
        </h2>

        <div className="md:columns-2 lg:columns-3 gap-8 space-y-8">
          {feedbacks?.map((tst, idx) => (
            <TestimonialCard testimonial={tst} key={idx} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionWrapper(Testimonials, "recenzije");

export const TestimonialCard = ({ testimonial }) => (
  <>
    <div className="break-inside-avoid aspect-auto p-8 border border-gray-100 rounded-3xl bg-white     shadow-2xl shadow-gray-600/10  ">
      <div className="flex gap-4">
        <div className="w-12 h-12">
          {testimonial?.avatar ? (
            <img
              src={testimonial?.avatar}
              className="h-12 w-12 rounded-full"
              alt="user-avatar"
            />
          ) : (
            <SVGS.DefaultAvatarSVG />
          )}
        </div>
        <div>
          <h6 className="text-lg font-medium text-gray-700  ">
            {testimonial?.name} {testimonial?.surname}
          </h6>
          <p className="text-sm text-gray-500  ">
            {new Date(testimonial.updatedAt).toLocaleDateString("hr-HR")}
          </p>
        </div>
      </div>

      <>
        <div className="w-full flex flex-row flex-wrap py-4">
          {Array.from({ length: 5 }, (_, index) => (
            <div
              key={index}
              className={`text-gray-400   p-1 ${
                testimonial.score >= index + 1 ? "text-yellow-500" : ""
              }`}
            >
              <SVGS.StarRating />
            </div>
          ))}
        </div>
        <p className="mt-2 text-lg">{testimonial.feedbackText}</p>
      </>
    </div>
    <div className="w-full flex justify-end flex-wrap p-4"></div>
  </>
);
